import { IUploadExcelRequest } from '../../../models/request/bus/uploadExcelRequest';
import { bus_diemdontra, BusDiemDonTraItemResponse } from '../../../models/response/bus/bus_diemdontra';
import { bus_loaidiemdon } from '../../../models/response/bus/bus_loaidiemdon';

export enum eBusDiemDonTraActionTypeIds {
	LOAD_START = "BUS_DIEMDONTRA_LOAD_START",
	LOAD_SUCCESS = "BUS_DIEMDONTRA_LOAD_SUCCESS",
	LOAD_ERROR = "BUS_DIEMDONTRA_LOAD_ERROR",

	LOAD_LOAIDIEMDON_START = "BUS_DIEMDONTRA_LOAD_LOAIDIEMDON_START",
	LOAD_LOAIDIEMDON_SUCCESS = "BUS_DIEMDONTRA_LOAD_LOAIDIEMDON_SUCCESS",
	LOAD_LOAIDIEMDON_ERROR = "BUS_DIEMDONTRA_LOAD_LOAIDIEMDON_ERROR",

	SHOW_DETAIL = "BUS_DIEMDONTRA_SHOW_DETAIL",
	CLOSE_DETAIL = "BUS_DIEMDONTRA_CLOSE_DETAIL",

	CHANGE_SELECTED_IDS = "BUS_DIEMDONTRA_CHANGE_SELECTED_IDS",

	SHOW_CONFIRM = "BUS_DIEMDONTRA_SHOW_CONFIRM",
	CLOSE_CONFIRM = "BUS_DIEMDONTRA_CLOSE_CONFIRM",

	SAVE_START = "BUS_DIEMDONTRA_SAVE_START",
	SAVE_SUCCESS = "BUS_DIEMDONTRA_SAVE_SUCCESS",
	SAVE_ERROR = "BUS_DIEMDONTRA_SAVE_ERROR",

	DELETE_START = "BUS_DIEMDONTRA_DELETE_START",
	DELETE_SUCCESS = "BUS_DIEMDONTRA_DELETE_SUCCESS",
	DELETE_ERROR = "BUS_DIEMDONTRA_DELETE_ERROR",

	SHOW_IMPORT_MODAL = "BUS_DIEMDONTRA_SHOW_IMPORT_MODAL",
	CLOSE_IMPORT_MODAL = "BUS_DIEMDONTRA_CLOSE_IMPORT_MODAL",

	VALIDATE_IMPORT_START = "BUS_DIEMDONTRA_VALIDATE_IMPORT_START",
	VALIDATE_IMPORT_SUCCESS = "BUS_DIEMDONTRA_VALIDATE_IMPORT_SUCCESS",
	VALIDATE_IMPORT_ERROR = "BUS_DIEMDONTRA_VALIDATE_IMPORT_ERROR",

	IMPORT_START = "BUS_DIEMDONTRA_IMPORT_START",
	IMPORT_SUCCESS = "BUS_DIEMDONTRA_IMPORT_SUCCESS",
	IMPORT_ERROR = "BUS_DIEMDONTRA_IMPORT_ERROR"
}

export interface IBusDiemDonTraLoadStart {
	type: eBusDiemDonTraActionTypeIds.LOAD_START,
	payload: number
}
export interface IBusDiemDonTraLoadSuccess {
	type: eBusDiemDonTraActionTypeIds.LOAD_SUCCESS,
	payload: BusDiemDonTraItemResponse[]
}
export interface IBusDiemDonTraLoadErr {
	type: eBusDiemDonTraActionTypeIds.LOAD_ERROR,
	payload: string
}
export interface IBusLoaiDiemDonLoadStart {
	type: eBusDiemDonTraActionTypeIds.LOAD_LOAIDIEMDON_START
}
export interface IBusLoaiDiemDonLoadSuccess {
	type: eBusDiemDonTraActionTypeIds.LOAD_LOAIDIEMDON_SUCCESS,
	payload: bus_loaidiemdon[]
}
export interface IBusLoaiDiemDonLoadErr {
	type: eBusDiemDonTraActionTypeIds.LOAD_LOAIDIEMDON_ERROR,
	payload: string
}
export interface IBusDiemDonTraShowDetail {
	type: eBusDiemDonTraActionTypeIds.SHOW_DETAIL,
	payload?: BusDiemDonTraItemResponse
}
export interface IBusDiemDonTraCloseDetail {
	type: eBusDiemDonTraActionTypeIds.CLOSE_DETAIL
}
export interface IBusDiemDonTraChangeSelectedIds {
	type: eBusDiemDonTraActionTypeIds.CHANGE_SELECTED_IDS,
	payload: number[]
}
export interface IBusDiemDonTraShowConfirm {
	type: eBusDiemDonTraActionTypeIds.SHOW_CONFIRM
}
export interface IBusDiemDonTraCloseConfirm {
	type: eBusDiemDonTraActionTypeIds.CLOSE_CONFIRM
}
export interface IBusDiemDonTraSaveStart {
	type: eBusDiemDonTraActionTypeIds.SAVE_START,
	payload: bus_diemdontra
}
export interface IBusDiemDonTraSaveSuccess {
	type: eBusDiemDonTraActionTypeIds.SAVE_SUCCESS,
	payload: boolean
}
export interface IBusDiemDonTraSaveErr {
	type: eBusDiemDonTraActionTypeIds.SAVE_ERROR,
	payload: string
}
export interface IBusDiemDonTraDeleteStart {
	type: eBusDiemDonTraActionTypeIds.DELETE_START,
	payload: number
}
export interface IBusDiemDonTraDeleteSuccess {
	type: eBusDiemDonTraActionTypeIds.DELETE_SUCCESS
}
export interface IBusDiemDonTraDeleteErr {
	type: eBusDiemDonTraActionTypeIds.DELETE_ERROR,
	payload: string
}
export interface IBusDiemDonTraShowImportModal {
	type: eBusDiemDonTraActionTypeIds.SHOW_IMPORT_MODAL
}
export interface IBusDiemDonTraCloseImportModal {
	type: eBusDiemDonTraActionTypeIds.CLOSE_IMPORT_MODAL
}
export interface IBusDiemDonTraValidateImportStart {
	type: eBusDiemDonTraActionTypeIds.VALIDATE_IMPORT_START,
	payload: IUploadExcelRequest
}
export interface IBusDiemDonTraValidateImportSuccess {
	type: eBusDiemDonTraActionTypeIds.VALIDATE_IMPORT_SUCCESS,
	payload: any[]
}
export interface IBusDiemDonTraValidateImportErr {
	type: eBusDiemDonTraActionTypeIds.VALIDATE_IMPORT_ERROR,
	payload: string
}
export interface IBusDiemDonTraImportStart {
	type: eBusDiemDonTraActionTypeIds.IMPORT_START,
	payload: IUploadExcelRequest
}
export interface IBusDiemDonTraImportSuccess {
	type: eBusDiemDonTraActionTypeIds.IMPORT_SUCCESS
}
export interface IBusDiemDonTraImportErr {
	type: eBusDiemDonTraActionTypeIds.IMPORT_ERROR,
	payload: string
}

export type IBusDiemDonTraActionTypes = IBusDiemDonTraLoadStart | IBusDiemDonTraLoadSuccess | IBusDiemDonTraLoadErr |
	IBusLoaiDiemDonLoadStart | IBusLoaiDiemDonLoadSuccess | IBusLoaiDiemDonLoadErr |
	IBusDiemDonTraShowDetail | IBusDiemDonTraCloseDetail |
	IBusDiemDonTraChangeSelectedIds |
	IBusDiemDonTraShowConfirm | IBusDiemDonTraCloseConfirm |
	IBusDiemDonTraSaveStart | IBusDiemDonTraSaveSuccess | IBusDiemDonTraSaveErr |
	IBusDiemDonTraDeleteStart | IBusDiemDonTraDeleteSuccess | IBusDiemDonTraDeleteErr |
	IBusDiemDonTraShowImportModal | IBusDiemDonTraCloseImportModal |
	IBusDiemDonTraValidateImportStart | IBusDiemDonTraValidateImportSuccess | IBusDiemDonTraValidateImportErr |
	IBusDiemDonTraImportStart | IBusDiemDonTraImportSuccess | IBusDiemDonTraImportErr
